import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Dashboard',
        icon: 'bi bi-speedometer2',
        link: '/dashboard'
    },
    {
        id: 2,
        label: 'Forms',
        link: '/forms',
        icon: 'bi bi-layout-text-window-reverse'
    },
    {
        id: 3,
        label: 'Donations',
        isTitle: true
    },
    {
        id: 4,
        label: 'Recurring - Paypal',
        icon: 'bi bi-paypal',
        link: '/donations/recurring/paypal',
    },
    {
        id: 5,
        label: 'Admin',
        isTitle: true
    },
    {
        id: 6,
        label: 'Users',
        icon: 'bi bi-person-rolodex',
        link: '/users',
    },
    {
        id: 7,
        label: 'Settings',
        link: '/settings',
        icon: 'bi bi-gear'
    },
]
